module.exports = __webpack_public_path__ + "img/23_107.52711e15.png";